import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { resetSelectedTableCells } from 'services/selectedTableCells/actions';

export interface OwnProps {}

interface StateProps {}

interface DispatchProps {
    resetSelectedTableCells: Function;
}

type IProps = StateProps & DispatchProps & OwnProps;

export class SelectedTableCellRowsClearDropdownItem extends React.PureComponent<
    IProps
> {
    handleClick = () => {
        this.props.resetSelectedTableCells();
    };

    render() {
        return <Dropdown.Item text="Deselect all" onClick={this.handleClick} />;
    }
}

export default connect<StateProps, DispatchProps, OwnProps>(
    null,
    { resetSelectedTableCells }
)(SelectedTableCellRowsClearDropdownItem);
